export { AdaptableMenuCard } from './adaptable-menu-card';
